<span
  class="link-text"
  [class.font-s-semibold]="size() === 'small'"
  [class.font-normal-semibold]="size() === 'normal'">
  <ng-content></ng-content>
</span>

@if (icon()) {
  <accredible-icon
    [icon]="icon()"
    [class.on-left]="iconPosition() === 'left'"
    [class.invert]="invertIconRtl()"
    [@rotateAnimation]="rotateIcon() ? 'rotated' : 'initial'" />
}
